export class CSSVariables {
    #styleElement;
    #vars = {};

    constructor() {
        this.#styleElement = document.createElement('style');
        document.body.append(this.#styleElement);

        this.#watchAction();
        this.#watch();
    }

    #watch() {
        const update = () => this.#watchAction();

        document.addEventListener('scroll', update);
        window.addEventListener('resize', update);
        window.addEventListener('load', update);
        document.addEventListener('orientationchange', update);
    }

    #watchAction() {
        const header =
            document.querySelector('#levcharity-w4f-site-header') ||
            document.querySelector('.wp-site-blocks > header');
        this.#vars['header-height'] = (header?.offsetHeight || 0) + 'px';

        this.#update();
    }

    #update() {
        let css = ':root{';
        Object.keys(this.#vars).forEach((varName) => {
            css += `--cat-${varName}:${this.#vars[varName]}`;
        });
        css += '}';

        this.#styleElement.innerHTML = css;
    }
}
